




































import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import isImageUrl from 'is-image-url';

import { CommentView } from '../store/models';
import { Emoji } from 'emoji-mart-vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { Actions as CommentsActions} from '@/modules/comments/store/actions';
import { commentsModuleName } from '@/modules/comments/store';
import { LoDashWrapper } from 'lodash';
const commentsModule = namespace(commentsModuleName);

interface IEmoticon {
  text: string;
  regEx: string;
  value: string;
}

@Component({
  components: {
    FontAwesomeIcon,
    Emoji,
  },
})
export default class CommentListItem extends Vue {

  @Prop() private comment!: CommentView;

  private $auth: any = (this as any).$auth;
  private lodash: any = (this as any)._;
  private uriPrefixes: string[] = ['http://', 'https://'];
  private emoticons: IEmoticon[] = [{text: ':)', regEx: ':\\)',    value: '🙂'},
                                    {text: ':-)', regEx: ':-\\)',  value: '🙂'},
                                    {text: ':D', regEx: ':D',      value: '😁'},
                                    {text: ':P', regEx: ':P',      value: '😋'},
                                    {text: ':/', regEx: ':\\/',    value: '😏'},
                                    {text: ':(', regEx: ':\\(',    value: '🙁'},
                                    {text: ';-)', regEx: ';-\\)',  value: '😉'},
                                    {text: ';)', regEx: ';\\)',    value: '😉'}];

  @commentsModule.Action(CommentsActions.DELETE_COMMENT) private deleteComment!: (id: number) => void;

  private showEditDeleteBtn(comment: CommentView) {
    return (this as any).$auth.isAuthenticated &&
      ((this as any).$auth.userProfile.isAdmin || (comment.userId && comment.userId === (this as any).$auth.userProfile.userId));
  }

  private editClicked(comment: CommentView) {
    this.$emit('editComment', comment);
  }

  private deleteClicked(id: number, text: string, dateTime: Date) {

    (this as any).$bvModal.msgBoxConfirm(
      `Czy na pewno chcesz usunąć komentarz "${ this.lodash.truncate(text) }"
        z ${this.$moment(dateTime).format('YYYY-MM-DD HH:mm')}?`, {
      title: 'Potwierdź usunięcie',
      size: 'sm',
      buttonSize: 'sm',
      okVariant: 'danger',
      okTitle: 'Usuń',
      cancelTitle: 'Anuluj',
      footerClass: 'p-2',
      hideHeaderClose: false,
      // centered: true,
    })
    .then((confirmed: boolean) => {
      if (confirmed) {
        this.deleteComment(id);
      }
    });
  }

  private prepareToDisplay(commentText: string): string {
    let commentHtml = commentText;

    // handle images and links
    commentHtml.split(/\s+/)
    .filter( (e) => this.uriPrefixes.some( (p) => e.includes(p)))
    .filter((v, i, a) => a.indexOf(v) === i)
    .forEach( (url) => {
      if (isImageUrl(url)) {
        // console.log('IMAGE: ' + url);
        const imgTag = `<a href="${url}" data-lightbox="${url}"><img src="${url}"></img></a>`;
        // commentHtml = this.lodash.replace(commentHtml, new RegExp(url, 'g'), imgTag);
        commentHtml = commentHtml.replace(url, imgTag);
      } else {
        // console.log('LINK: ' + url);
        const linkTag = `<a target="_blank" href="${url}">${ this.lodash.truncate(url)}</a>`;
        commentHtml = commentHtml.replace(url, linkTag);
      }
    });

    // handle new lines
    commentHtml = this.lodash.replace(commentHtml, new RegExp('(\n)|(\r\n)', 'g'), '<br />');

    // handle emoticons
    commentHtml.split(/\s+/)
    .filter( (e) => this.emoticons.some( (i) => e === i.text))
    .filter((v, i, a) => a.indexOf(v) === i)
    .forEach( (emoticon) => {
      const emot = (this.emoticons.find( (e) => e.text === emoticon) as IEmoticon);
      commentHtml = this.lodash.replace(commentHtml, new RegExp(emot.regEx, 'g'), emot.value);
    });

    return commentHtml;
  }

  get pictureUrl(): string {
    return this.comment.userPictureUrl ?
      this.comment.userPictureUrl.replace('~/', 'https://muchoborwroclaw.pl/') :
      'https://muchoborwroclaw.pl/Images/avatar2.jpg';
  }


}
